import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import FooterPanel from '../components/FooterPanel';
import CircleButton from '../components/CircleButton';
import MessageModal from '../components/MessageModal';
import BigMac from '../assets/img/big-mac.png';

const SuccessHeading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 72px;
  line-height: 0.85em;
  letter-spacing: -0.03em;
  margin: 0;
  text-align: center;
`;

const ButtonText = styled.p`
  position: absolute;
  top: 40px;
  font-family: 'Speedee Bold';
  font-size: 20px;
  font-weight: bold;
  line-height: 0.95em;
  letter-spacing: -0.05em;
  margin: 26px 0 0 0;
`;

const SuccessWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
`;

function Success({ ...props }) {
  const { setPage, setPrizeCode, tapPhrase, score, correctPhrase } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalDetails, setModalDetails] = useState(false);
  const [revealModal, setRevealModal] = useState(false);

  useEffect(() => {
    if (window.socket) {
      window.closeSocket();
    }
  }, []);

  const fetchPrizeCode = async () => {
    setIsSubmitting(true);

    const token = await window.AwsWafIntegration.getToken();

    if (!token) {
      setModalDetails({
        title: 'Error',
        message: 'An error has been encountered. Please refresh the page and try again.',
        action: {
          label: 'Okay',
          refreshPage: true
        }
      });
      setRevealModal(true);
      return;
    } else {
      const response = await fetch('https://5ghwfe8xpj.execute-api.ap-southeast-2.amazonaws.com/stg/', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-aws-waf-token': token
        },
        body: JSON.stringify({
          name: '',
          attempts: []
        })
      })
      .catch((error) => {
        setIsSubmitting(false);
        setModalDetails({
          title: 'Error',
          message: 'An error has been encountered. Please try again.',
          action: {
            label: 'Okay'
          }
        });
        setRevealModal(true);
      });
      
      response.json()
        .then(data => {
          if (data?.prizeCode) {
            setPrizeCode(data.prizeCode);
            setPage('redeem');
          } else {
            setIsSubmitting(false);
            setModalDetails({
              title: 'Great work!',
              message: 'All offers have now been exhausted, but check the MyMacca’s app for other great deals.',
              action: {
                label: 'Go to MyMacca’s app',
                externalUrl: 'https://mcdvouchers.page.link/?link=https://mcdonalds.com.au/mobileordering&apn=com.mcdonalds.au.gma&isi=1105300599&ibi=com.mcdonalds.gma.au'
              }
            });
            setRevealModal(true);
          }
        })
        .catch((error) => {
          setIsSubmitting(false);
          setModalDetails({
            title: 'Error',
            message: 'An error has been encountered. Please try again.',
            action: {
              label: 'Okay'
            }
          });
          setRevealModal(true);
        });
    }  
  };

  return (
    <SuccessWrapper>
      <div style={{ position: 'relative' }}>
        <SuccessHeading>{score >= 60 || tapPhrase === correctPhrase ? 'Well done!' : 'It’s on us!'}</SuccessHeading>
        <p style={{ textAlign: 'center', fontSize: 24, lineHeight: 1.25, letterSpacing: '-2%' }}>Tap below to claim your prize</p>
      </div>
      <img src={BigMac} alt="Big Mac" style={{ position: 'absolute', bottom: '108px', left: 0, width: 'calc(100vw + 10px)', height: 'auto', marginLeft: -16 }}/>
      <FooterPanel>
        <CircleButton onClick={() => fetchPrizeCode()} disabled={isSubmitting}>
          <svg width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.2532 12.3923C29.2532 11.9252 29.0573 11.4732 28.7108 11.1418L18.8118 1.24276C18.4201 0.866085 18.0133 0.700348 17.5914 0.700348C16.6271 0.700348 15.934 1.37836 15.934 2.29745C15.934 2.77959 16.1299 3.1864 16.4312 3.48774L19.8213 6.923L24.1907 10.9157L20.6952 10.7048H2.43401C1.42453 10.7048 0.731445 11.3979 0.731445 12.3923C0.731445 13.3717 1.42453 14.0647 2.43401 14.0647H20.6952L24.1907 13.8538L19.8213 17.8466L16.4312 21.2818C16.1299 21.5832 15.934 21.99 15.934 22.4721C15.934 23.3912 16.6271 24.0692 17.5914 24.0692C18.0133 24.0692 18.4201 23.9035 18.7817 23.5569L28.7108 13.6278C29.0573 13.2963 29.2532 12.8443 29.2532 12.3923Z" fill="white"/>
          </svg>
        </CircleButton>
        <ButtonText>{!isSubmitting ? 'Let’s go!' : 'Please wait...'}</ButtonText>
      </FooterPanel>
      { revealModal && (
        <MessageModal details={modalDetails} setRevealModal={setRevealModal} />
      ) }
    </SuccessWrapper>
  );
}

export default Success;